(() => {
  const init = (root) => {
    if (root.dataset.unboxReady === 'true') return;
    root.dataset.unboxReady = 'true';

    const canvas = root.querySelector('[data-unbox-canvas]');
    const bar = root.querySelector('[data-unbox-bar]');
    const caps = [...root.querySelectorAll('[data-unbox-caption]')];
    const veil = root.querySelector('[data-unbox-veil]');
    if (!canvas) return;

    const ctx = canvas.getContext('2d', { alpha: false });
    const total = parseInt(root.dataset.frames, 10) || 120;
    const prefix = root.dataset.prefix || 'spot-unbox-';
    const ext = root.dataset.ext || 'jpg';
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Shopify-Asset-URL aus dem Script-Tag ableiten
    const scriptEl = document.querySelector('script[src*="spot-unbox.js"]');
    const assetBase = scriptEl ? scriptEl.src.replace(/spot-unbox\.js.*$/, '') : '/';
    const pad = (n) => String(n).padStart(4, '0');
    const urlFor = (i) => `${assetBase}${prefix}${pad(i)}.${ext}`;

    const images = new Array(total + 1);
    let loaded = 0;
    let current = 0;
    let pending = null;

    const draw = (i) => {
      const img = images[i];
      if (!img || !img.complete || !img.naturalWidth) return;
      // cover: Bild fuellt das Canvas ohne Verzerrung
      const cw = canvas.width, ch = canvas.height;
      const s = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
      const w = img.naturalWidth * s, h = img.naturalHeight * s;
      ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
    };

    const load = (i, priority) => {
      if (images[i]) return images[i];
      const img = new Image();
      img.decoding = 'async';
      if (!priority) img.loading = 'eager';
      img.src = urlFor(i);
      img.onload = () => {
        loaded++;
        if (i === current) draw(i);
        if (pending !== null && pending === i) { draw(i); pending = null; }
      };
      images[i] = img;
      return img;
    };

    // Erste Frames sofort, Rest gestaffelt
    const preloadFirst = 12;
    for (let i = 1; i <= Math.min(preloadFirst, total); i++) load(i, true);

    const loadRest = () => {
      let i = preloadFirst + 1;
      const step = () => {
        const until = Math.min(i + 6, total);
        for (; i <= until; i++) load(i);
        if (i <= total) {
          ('requestIdleCallback' in window)
            ? requestIdleCallback(step, { timeout: 300 })
            : setTimeout(step, 60);
        }
      };
      step();
    };
    if (document.readyState === 'complete') loadRest();
    else window.addEventListener('load', loadRest, { once: true });

    const setCaption = (p) => {
      // drei Abschnitte passend zur Kamerafahrt; im Flug bleibt das Bild frei
      let active = 0;
      if (p < 0.16) active = 1;
      else if (p < 0.38) active = 2;
      else active = 0;
      caps.forEach((c) => c.classList.toggle('is-active', c.dataset.unboxCaption === String(active)));
    };

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        const r = root.getBoundingClientRect();
        const scrollable = r.height - window.innerHeight;
        if (scrollable <= 0) return;

        // Die Fahrt beginnt bereits, waehrend die Sektion ins Bild kommt:
        // der Vorlauf zaehlt ab dem Moment, in dem die Oberkante unten auftaucht.
        const LEAD = Math.min(window.innerHeight * 0.22, 170);
        const p = Math.min(1, Math.max(0, (LEAD - r.top) / (scrollable + LEAD)));
        const frame = Math.min(total, Math.max(1, Math.round(p * (total - 1)) + 1));
        if (frame !== current) {
          current = frame;
          if (images[frame] && images[frame].complete) draw(frame);
          else { pending = frame; load(frame, true); }
        }
        if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
        setCaption(p);

        // Blende haengt an der Sektionskante, nicht am Fortschritt:
        // sie greift nur, solange der Rand der Sektion im Bild ist.
        if (veil) {
          const BAND = Math.min(150, window.innerHeight * 0.18);
          let v = 0;
          // Oberkante faehrt von unten ins Bild -> r.top geht von +BAND auf 0
          if (r.top > 0) v = Math.min(1, r.top / BAND);
          // Unterkante verlaesst das Bild -> Abstand zum Viewport-Ende
          const restUnten = r.bottom - window.innerHeight;
          if (restUnten < BAND) v = Math.max(v, Math.min(1, 1 - restUnten / BAND));
          v = v * v * (3 - 2 * v);
          root.style.setProperty('--spot-veil', v.toFixed(3));
        }
      });
    };

    if (reduce) {
      load(Math.round(total * 0.6), true);
      caps.forEach((c) => c.classList.add('is-active'));
      return;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  };

  const boot = () => document.querySelectorAll('[data-spot-unbox]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
